import techConfig from './techConfig';

const config = {
  displaySSNFieldRegistration: true,
  mobileEmailAuthLength: 6,
  QRCodeInput: ['MemberID', 'LastName'],
  PinErrorMaxCount: '7',
  PinWarningCount: '5',
  SessionTimedOut: '900',
  requestTimeOut: '60000',
  CardRefreshWaring: '30',
  CardRefreshError: '60',
  CardRefreshInterval: '30000',
  MaxFileSizeToUpload: 5242880, // 5 MB in bytes
  MaxNoOfFilesCanUpload: 3,
  notificationHideTime: 9000,
  MaxNoOfFavorite: 3,
  optOutRefreshError: '5',
  zipCode: '',
  Active: 'Active',
  Temporary: 'Temporary',
  InActive: 'Inactive',
  None: '---',
  A: 'A',
  I: 'I',
  D: 'D',
  T: 'T',
  ...techConfig,
};

export default config;
